import { createContext, useContext } from "react";
import { ValidationResult } from "../../hooks/useFormValidation";

export type FormFieldValue = string | number | boolean | null | undefined | (string | number)[];

export interface FormDataType {
  [key: string]: FormFieldValue;
}

interface FormContextType {
  formData: FormDataType;
  validationResult: ValidationResult;
  updateField: (fieldName: string, value: FormFieldValue) => void;
  touchField: (fieldName: string) => void;
  resetForm: () => void;
  isSubmitted: boolean;
}

const FormContext = createContext<FormContextType | null>(null);

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a Form component");
  }
  return context;
};

export { FormContext };
